import React, { CSSProperties } from 'react'
import ReactModal from 'react-modal'

interface ModalProps {
    isOpen: boolean,
    children?: React.ReactNode,
    buttonOnClick(): void,
    showX?: boolean
}

const contentProps:CSSProperties = {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    textAlign             : 'center',
    overflowY             : 'auto',
    maxHeight             : '85vh',
    maxWidth              : '90vw',
    width                 : 'auto',
    backgroundColor       : 'rgba(30, 41, 59, 0.98)',
    backdropFilter        : 'blur(20px)',
    borderRadius          : '16px',
    padding               : '24px',
    border                : '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow             : '0 20px 60px rgba(0, 0, 0, 0.5)',
    zIndex                : 2000,
    color                 : '#ffffff'
}

const overlayProps:CSSProperties = {
    zIndex                : 2000,
    backgroundColor       : 'rgba(0, 0, 0, 0.85)',
    backdropFilter        : 'blur(4px)'
}

const Modal = ( props:ModalProps ) => {
    return (
        <ReactModal
            isOpen={props.isOpen}
            style={{
                content : contentProps,
                overlay : overlayProps
            }}
        >
            <div style={{ marginBottom: props.showX === false ? 0 : 15 }}>
                {props.showX === false ? "" : <button
                    onClick={()=>{ props.buttonOnClick() }}
                    style={{
                        top: 12,
                        right: 12,
                        position: "absolute",
                        fontSize: 24,
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                        color: "#ffffff",
                        border: "1px solid rgba(255, 255, 255, 0.2)",
                        borderRadius: "8px",
                        width: "36px",
                        height: "36px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        outline: "none",
                        fontWeight: 700
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "rgba(239, 68, 68, 0.2)"
                        e.currentTarget.style.borderColor = "rgba(239, 68, 68, 0.5)"
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.1)"
                        e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)"
                    }}
                >
                    ✕
                </button>}
            </div>
            {props.children}
        </ReactModal>
    )
}

export default Modal